import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { logError } from '../utils/log';

export const LeagueTeamsPage = ({ userRole, navigate }) => {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTeams = async () => {
            setLoading(true);
            try {
                const teamsSnapshot = await getDocs(collection(db, "teams"));
                const teamsList = teamsSnapshot.docs
                    .map(doc => ({ id: doc.id, ...doc.data() }))
                    .filter(team => !team.archived); // Filter for active/current teams only
                setTeams(teamsList.sort((a, b) => a.name.localeCompare(b.name))); // Sort teams alphabetically
            } catch (error) {
                logError("Error fetching teams: ", error);
            }
            setLoading(false);
        };

        if (userRole) {
            fetchTeams();
        }
    }, [userRole]);

    if (!userRole) {
        return <p className="text-xl text-danger text-center">Please log in to view league teams.</p>;
    }

    if (loading) {
        return <div className="text-center">Loading teams...</div>;
    }

    return (
        <div className="space-y-6">
            <h2 className="page-title heading-primary-1 text-4xl font-extrabold text-center mb-6">League Teams</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {teams.map(team => (
                    <button
                        key={team.id}
                        onClick={() => navigate('Team Details', { teamId: team.id })}
                        className="card rounded-lg shadow-md p-6 text-center transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-xl focus:outline-none"
                    >
                        <h3 className="heading-primary-1 text-xl font-bold">{team.name}</h3>
                        <p className="text-sm text-muted mt-1">Home: {team.homeLocation}</p>
                    </button>
                ))}
            </div>
        </div>
    );
};